/* Actual calendar-week countdown. All visitors share the same Monday
   midnight boundary in America/New_York, including DST changes. */
(() => {
  const zone = 'America/New_York';
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit',
    weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit',
    hourCycle: 'h23'
  });
  const weekdayNumber = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  const zonedParts = (time) => Object.fromEntries(
    formatter.formatToParts(time).filter((part) => part.type !== 'literal').map((part) => [part.type, part.value])
  );
  const nextMondayMidnight = (now) => {
    const local = zonedParts(now);
    const weekday = weekdayNumber[local.weekday];
    const daysToNextMonday = (8 - weekday) % 7 || 7;
    const midnightAsUtc = Date.UTC(Number(local.year), Number(local.month) - 1,
      Number(local.day) + daysToNextMonday);
    // Determine the Eastern offset at the *target* date rather than today.
    // This also accounts for the Sunday when daylight saving time changes.
    const atTarget = zonedParts(new Date(midnightAsUtc));
    const localAsUtc = Date.UTC(Number(atTarget.year), Number(atTarget.month) - 1,
      Number(atTarget.day), Number(atTarget.hour), Number(atTarget.minute),
      Number(atTarget.second));
    return midnightAsUtc - (localAsUtc - midnightAsUtc);
  };
  const twoDigits = (value) => String(value).padStart(2, '0');
  const update = () => {
    const timers = document.querySelectorAll('[data-weekly-offer-countdown]');
    if (!timers.length) return;
    const now = Date.now();
    const remainingSeconds = Math.max(0, Math.ceil((nextMondayMidnight(new Date(now)) - now) / 1000));
    const fields = [
      ['[data-weekly-days]', Math.floor(remainingSeconds / 86400)],
      ['[data-weekly-hours]', Math.floor((remainingSeconds % 86400) / 3600)],
      ['[data-weekly-minutes]', Math.floor((remainingSeconds % 3600) / 60)],
      ['[data-weekly-seconds]', remainingSeconds % 60]
    ];
    timers.forEach((timer) => fields.forEach(([selector, value]) => {
      const field = timer.querySelector(selector);
      if (field) field.textContent = twoDigits(value);
    }));
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update, { once: true });
  } else {
    update();
  }
  window.setInterval(update, 1000);
  // Shopify theme editor can replace individual sections without a full reload.
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) update();
  });
})();
